import styled from '@emotion/styled';

import { COLOR_BRAND_SOFT, COLOR_BRAND_SOFT_TEXT, FONT_MONO, RADIUS_SM } from './utils/variables';

export const SlugChip = styled.code`
  font-family: ${FONT_MONO};
  font-size: 12px;
  color: ${COLOR_BRAND_SOFT_TEXT};
  background: ${COLOR_BRAND_SOFT};
  padding: 4px 8px;
  border-radius: ${RADIUS_SM};
  border: none;
`;
